import React from 'react'
import { View, StyleSheet } from '@react-pdf/renderer'

const styles = StyleSheet.create({
    grid: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        height: '100%',
        paddingRight: 3,
        position: 'relative',
        opacity: 0.25,
        backgroundColor: 'rgb(226 232 240)',
    },
    gridLast: {
        height: '90%',
        borderRightWidth: 1,
        borderRightStyle: 'solid',
        borderRightColor: 'rgb(204,214,228)',
    }
});

const initialValue = 0;
const endValue = 5;
const finalArray = [];

for (let n = initialValue; n <= endValue; n += 1) {
    finalArray.push({ label: n });
}

const TableGridQuinary = () => {
    return (
        <View style={styles.grid}>
            {finalArray.map((item, index) => {
                return (
                    <View
                        key={index}
                        style={{
                            width: '20%',
                            height: '90%',
                            borderLeftStyle: 'solid',
                            borderLeftColor: 'rgb(204,214,228)',
                            borderLeftWidth: 1,
                        }}
                    ></View>
                );
            })}
            <View style={styles.gridLast}></View>
        </View>
    )
}

export default TableGridQuinary